import { render, staticRenderFns } from "./loginRetailer.vue?vue&type=template&id=20f9266d&scoped=true"
import script from "./loginRetailer.vue?vue&type=script&lang=js"
export * from "./loginRetailer.vue?vue&type=script&lang=js"
import style0 from "./loginRetailer.vue?vue&type=style&index=0&id=20f9266d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f9266d",
  null
  
)

export default component.exports